import dictionary from "./dictionary";
import numeral from "numeral";
import { DirectDebitPeriodType } from "../types/DirectDebitTypes";
import moment from "moment-jalaali";

export const mobileFormat = (mobile) => {
  if (mobile && mobile[0] === "+") {
    return mobile.replace("+98", "0");
  } else {
    return mobile;
  }
};

export const dateObjectToJalaali = (date) => {
  return moment(date).format("jYYYY/jMM/jDD");
};

export const toFarsi = (word) => {
  if (dictionary && dictionary.hasOwnProperty(word)) {
    return dictionary[word];
  } else {
    return word;
  }
};

export const calcualteDay = (day, period) => {
  if (period === DirectDebitPeriodType.DAILY) return "هر روز";
  if (period === DirectDebitPeriodType.WEEKLY) {
    switch (day) {
      case 1:
        return "دوشنبه";
      case 2:
        return "سه‌شنبه";
      case 3:
        return "چهارشنبه";
      case 4:
        return "پنج‌شنبه";
      case 5:
        return "جمعه";
      case 6:
        return "شنبه";
      case 7:
        return "یک‌شنبه";
      default:
        return day;
    }
  }
  if (period === DirectDebitPeriodType.MONTHLY) {
    switch (day) {
      case 100:
        return "آخرین روز ماه";
      default:
        return day + " ام";
    }
  }
};

export const getDirectDebitSentence = (subscription) => {
  if (subscription.period === DirectDebitPeriodType.DAILY) {
    return `هر روز ${toToman(subscription.amount)} تومان`;
  }
  if (subscription.period === DirectDebitPeriodType.WEEKLY) {
    let weekdayName = "";
    switch (subscription.day) {
      case 2:
        weekdayName = "سه‌شنبه";
        break;
      case 3:
        weekdayName = "چهارشنبه";
        break;
      case 4:
        weekdayName = "پنج‌شنبه";
        break;
      case 5:
        weekdayName = "جمعه";
        break;
      case 6:
        weekdayName = "شنبه";
        break;
      case 7:
        weekdayName = "یک‌شنبه";
        break;
      case 1:
        weekdayName = "دوشنبه";
        break;
      default:
        weekdayName = subscription.day;
    }
    return `هر ${weekdayName} ${toToman(subscription.amount)} تومان`;
  }
  if (subscription.period === DirectDebitPeriodType.MONTHLY) {
    switch (subscription.day) {
      case 100:
        return `آخرین روز هر ماه ${toToman(subscription.amount)} تومان`;
      default:
        return `${subscription.day} ام هر ماه ${toToman(
          subscription.amount
        )} تومان`;
    }
  }
};

export const getDirectDebitPeriodTitle = (subscription) => {
  if (subscription.period === DirectDebitPeriodType.DAILY) {
    return `هر روز`;
  }
  if (subscription.period === DirectDebitPeriodType.WEEKLY) {
    let weekdayName = "";
    switch (subscription.day) {
      case 2:
        weekdayName = "سه‌شنبه";
        break;
      case 3:
        weekdayName = "چهارشنبه";
        break;
      case 4:
        weekdayName = "پنج‌شنبه";
        break;
      case 5:
        weekdayName = "جمعه";
        break;
      case 6:
        weekdayName = "شنبه";
        break;
      case 7:
        weekdayName = "یک‌شنبه";
        break;
      case 1:
        weekdayName = "دوشنبه";
        break;
      default:
        weekdayName = subscription.day;
    }
    return `هفتگی / ${weekdayName} ها`;
  }
  if (subscription.period === DirectDebitPeriodType.MONTHLY) {
    switch (subscription.day) {
      case 100:
        return `ماهانه / آخرین روز ماه`;
      default:
        return `ماهانه / ${subscription.day} ام`;
    }
  }
};

export const toToman = (amount) => {
  const formattedAmount = numeral(
    Math.abs(Math.round(Math.round(amount) / 10))
  ).format("0,0");
  return amount < 0 ? `${formattedAmount}-` : formattedAmount;
};

export const toUnSignedToman = (amount) => {
  const formattedAmount = numeral(
    Math.abs(Math.round(Math.round(amount) / 10))
  ).format("0,0");
  return formattedAmount;
};

export const toBilionToman = (amount) => {
  const formattedAmount = numeral(
    Math.abs(Math.round(Math.round(amount) / 10000000000))
  ).format("0,0");
  return formattedAmount;
};

export const removeNonNumeric = (num) => num.toString().replace(/[^0-9]/g, "");

export const ibanToBank = (iban = "", banks = []) => {
  if (iban === "") {
    return null;
  }
  const ibanCode = iban.substring(2, 5);
  const bank = banks.find((bank) => bank.ibanCode === ibanCode);
  return bank;
};
